export const PAYMENT_TYPE_LIST_REQUEST = 'PAYMENT_TYPE_LIST_REQUEST'
export const PAYMENT_TYPE_LIST_SUCCESS = 'PAYMENT_TYPE_LIST_SUCCESS'
export const PAYMENT_TYPE_LIST_FAIL    = 'PAYMENT_TYPE_LIST_FAIL'

export const PAYMENT_TYPE_DETAILS_REQUEST = 'PAYMENT_TYPE_DETAILS_REQUEST'
export const PAYMENT_TYPE_DETAILS_SUCCESS = 'PAYMENT_TYPE_DETAILS_SUCCESS'
export const PAYMENT_TYPE_DETAILS_FAIL    = 'PAYMENT_TYPE_DETAILS_FAIL'
export const PAYMENT_TYPE_DETAILS_RESET   = 'PAYMENT_TYPE_DETAILS_RESET'

export const PAYMENT_TYPE_CREATE_REQUEST = 'PAYMENT_TYPE_CREATE_REQUEST'
export const PAYMENT_TYPE_CREATE_SUCCESS = 'PAYMENT_TYPE_CREATE_SUCCESS'
export const PAYMENT_TYPE_CREATE_FAIL    = 'PAYMENT_TYPE_CREATE_FAIL'
export const PAYMENT_TYPE_CREATE_RESET   = 'PAYMENT_TYPE_CREATE_RESET'

export const PAYMENT_TYPE_UPDATE_REQUEST = 'PAYMENT_TYPE_UPDATE_REQUEST'
export const PAYMENT_TYPE_UPDATE_SUCCESS = 'PAYMENT_TYPE_UPDATE_SUCCESS'
export const PAYMENT_TYPE_UPDATE_FAIL    = 'PAYMENT_TYPE_UPDATE_FAIL'
export const PAYMENT_TYPE_UPDATE_RESET   = 'PAYMENT_TYPE_UPDATE_RESET'

export const PAYMENT_TYPE_DELETE_REQUEST = 'PAYMENT_TYPE_DELETE_REQUEST'
export const PAYMENT_TYPE_DELETE_SUCCESS = 'PAYMENT_TYPE_DELETE_SUCCESS'
export const PAYMENT_TYPE_DELETE_FAIL    = 'PAYMENT_TYPE_DELETE_FAIL'

export const USER_PAYMENT_METHOD_LIST_REQUEST  = 'USER_PAYMENT_METHOD_LIST_REQUEST'
export const USER_PAYMENT_METHOD_LIST_SUCCESS  = 'USER_PAYMENT_METHOD_LIST_SUCCESS'
export const USER_PAYMENT_METHOD_LIST_FAIL     = 'USER_PAYMENT_METHOD_LIST_FAIL'

export const USER_PAYMENT_METHOD_ADD_REQUEST   = 'USER_PAYMENT_METHOD_ADD_REQUEST'
export const USER_PAYMENT_METHOD_ADD_SUCCESS   = 'USER_PAYMENT_METHOD_ADD_SUCCESS'
export const USER_PAYMENT_METHOD_ADD_FAIL      = 'USER_PAYMENT_METHOD_ADD_FAIL'
export const USER_PAYMENT_METHOD_ADD_RESET     = 'USER_PAYMENT_METHOD_ADD_RESET'

export const USER_PAYMENT_METHOD_DELETE_REQUEST = 'USER_PAYMENT_METHOD_DELETE_REQUEST'
export const USER_PAYMENT_METHOD_DELETE_SUCCESS = 'USER_PAYMENT_METHOD_DELETE_SUCCESS'
export const USER_PAYMENT_METHOD_DELETE_FAIL    = 'USER_PAYMENT_METHOD_DELETE_FAIL'
